import backAccesoCapitalUrl from "../img/back-acceso_a_capital.webp";
import backAccesoCapital1440Url from "../img/back-acceso_a_capital-1440.webp";
import backAccesoCapital1024Url from "../img/back-acceso_a_capital-1024.webp";
import backAccesoCapital768Url from "../img/back-acceso_a_capital-768.webp";
import backDesarrolloCorporativoUrl from "../img/back-desarrollo_corporativo.webp";
import backDesarrolloCorporativo1440Url from "../img/back-desarrollo_corporativo-1440.webp";
import backDesarrolloCorporativo1024Url from "../img/back-desarrollo_corporativo-1024.webp";
import backDesarrolloCorporativo768Url from "../img/back-desarrollo_corporativo-768.webp";
import backInnovacionUrl from "../img/back-innovacion.webp";
import backInnovacion1440Url from "../img/back-innovacion-1440.webp";
import backInnovacion1024Url from "../img/back-innovacion-1024.webp";
import backInnovacion768Url from "../img/back-innovacion-768.webp";
import backInternacionalizacionUrl from "../img/back-internacionalizacion.webp";
import backInternacionalizacion1440Url from "../img/back-internacionalizacion-1440.webp";
import backInternacionalizacion1024Url from "../img/back-internacionalizacion-1024.webp";
import backInternacionalizacion768Url from "../img/back-internacionalizacion-768.webp";
import backOtrasAreasUrl from "../img/back-otras-areas.webp";
import backOtrasAreas1440Url from "../img/back-otras-areas-1440.webp";
import backOtrasAreas1024Url from "../img/back-otras-areas-1024.webp";
import backOtrasAreas768Url from "../img/back-otras-areas-768.webp";
import backPosicionamientoUrl from "../img/back-posicionamiento.webp";
import backPosicionamiento1440Url from "../img/back-posicionamiento-1440.webp";
import backPosicionamiento1024Url from "../img/back-posicionamiento-1024.webp";
import backPosicionamiento768Url from "../img/back-posicionamiento-768.webp";

export const BASE_URL = import.meta.env.BASE_URL || "/";

export function withBase(path) {
  const normalizedBase = BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`;
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return new URL(normalizedPath, window.location.origin + normalizedBase).pathname;
}

export function stripBase(pathname) {
  const normalizedBase = (BASE_URL.endsWith("/") ? BASE_URL : `${BASE_URL}/`).replace(/\/+$/, "");

  if (!normalizedBase || normalizedBase === "") {
    return pathname || "/";
  }

  if (pathname === normalizedBase) {
    return "/";
  }

  return pathname.startsWith(`${normalizedBase}/`) ? pathname.slice(normalizedBase.length) || "/" : pathname;
}

export const SERVICES = [
  {
    href: "desarrollo-corporativo",
    hrefEn: "corporate-development",
    path: "/desarrollo-corporativo",
    accentVar: "--accent-desarrollo-corporativo",
    label: "DESARROLLO CORPORATIVO",
    labelEn: "CORPORATE DEVELOPMENT",
    imageUrl: backDesarrolloCorporativoUrl,
    imageUrl1440: backDesarrolloCorporativo1440Url,
    imageUrl1024: backDesarrolloCorporativo1024Url,
    imageUrl768: backDesarrolloCorporativo768Url
  },
  {
    href: "acceso-capital",
    hrefEn: "capital-access",
    path: "/acceso-capital",
    accentVar: "--accent-acceso-capital",
    label: "ACCESO A CAPITAL",
    labelEn: "CAPITAL ACCESS",
    imageUrl: backAccesoCapitalUrl,
    imageUrl1440: backAccesoCapital1440Url,
    imageUrl1024: backAccesoCapital1024Url,
    imageUrl768: backAccesoCapital768Url
  },
  {
    href: "internacionalizacion",
    hrefEn: "internationalization",
    path: "/internacionalizacion",
    accentVar: "--accent-internacionalizacion",
    label: "INTERNACIONALIZACIÓN",
    labelEn: "INTERNATIONALIZATION",
    imageUrl: backInternacionalizacionUrl,
    imageUrl1440: backInternacionalizacion1440Url,
    imageUrl1024: backInternacionalizacion1024Url,
    imageUrl768: backInternacionalizacion768Url
  },
  {
    href: "innovacion",
    hrefEn: "innovation",
    path: "/innovacion",
    accentVar: "--accent-innovacion",
    label: "INNOVACIÓN",
    labelEn: "INNOVATION",
    imageUrl: backInnovacionUrl,
    imageUrl1440: backInnovacion1440Url,
    imageUrl1024: backInnovacion1024Url,
    imageUrl768: backInnovacion768Url
  },
  {
    href: "posicionamiento-estrategico",
    hrefEn: "strategic-positioning",
    path: "/posicionamiento-estrategico",
    accentVar: "--accent-posicionamiento-estrategico",
    label: "POSICIONAMIENTO ESTRATÉGICO",
    labelEn: "STRATEGIC POSITIONING",
    imageUrl: backPosicionamientoUrl,
    imageUrl1440: backPosicionamiento1440Url,
    imageUrl1024: backPosicionamiento1024Url,
    imageUrl768: backPosicionamiento768Url
  },
  {
    href: "otras-areas",
    hrefEn: "other-areas",
    path: "/otras-areas",
    accentVar: "--accent-otras-areas",
    label: "OTRAS ÁREAS",
    labelEn: "OTHER AREAS",
    imageUrl: backOtrasAreasUrl,
    imageUrl1440: backOtrasAreas1440Url,
    imageUrl1024: backOtrasAreas1024Url,
    imageUrl768: backOtrasAreas768Url
  }
];
